import React from "react";
import Page from "../../Components/Page";
import { Card, CardContent } from "@mui/material";

const WithdrawsB2C = () => {
  return (
    <Page title={"Withdraws/B2C Recon"}>
      <Card>
        <CardContent>
          <form></form>
        </CardContent>
      </Card>
    </Page>
  );
};

export default WithdrawsB2C;
